import Script from 'next/script';
import { type ComponentProps, useCallback, useState } from 'react';

type ScriptProps = ComponentProps<typeof Script>;
type GeeTestScriptProps = Omit<ScriptProps, 'src'>;

const GEETEST_FALLBACK = ['geetest', 'geevisit'];

export const GeeTestScript = ({ onError: onErrorProps, ...props }: GeeTestScriptProps) => {
	const [fallbackIndex, setFallbackIndex] = useState(0);
	const host = GEETEST_FALLBACK[fallbackIndex];

	const onError = useCallback<Exclude<ScriptProps['onError'], undefined>>(
		(...args) => {
			setFallbackIndex(prev => Math.min(prev + 1, GEETEST_FALLBACK.length - 1));

			if (typeof onErrorProps === 'function') onErrorProps(...args);
		},
		[onErrorProps]
	);

	return <Script key={host} src={`https://static.${host}.com/v4/gt4.js`} onError={onError} {...props} />;
};
